import axios from "axios"

export const ApiService = () => axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}`,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`
    }
})